import type { ModuleRecommendation, ScoreModuleRecommendations, ScoreType } from "../../types/scores";

function normalizeTriggerReason(reason: string) {
  return reason.trim();
}

export function moduleRecommendationBucket(
  moduleOrder: number,
  triggerReasons: string[]
): ScoreType {
  const reasons = triggerReasons.map(normalizeTriggerReason);
  const has = (...items: string[]) => items.some((item) => reasons.includes(item));

  /*
    A module is displayed in exactly one score card.
    Ownership is based on the strongest/directest trigger source:
    - Ext_PRS owns practical readiness gaps Q31-Q45 and Medical flag.
    - PBG owns personal exposure, vulnerability, information quality and SPoF triggers.
    - E_Score remains available for future EKS-A..EKS-J action modules.
  */

  if ([1, 2, 3].includes(moduleOrder)) return "Ext_PRS";

  if (moduleOrder === 4) {
    if (has("Q35", "Q43")) return "Ext_PRS";
    return "PBG";
  }

  if (moduleOrder === 5) {
    if (has("Q24-Q27", "Q21")) return "PBG";
    return "Ext_PRS";
  }

  if (moduleOrder === 6) {
    if (has("Q20")) return "PBG";
    return "Ext_PRS";
  }

  if (moduleOrder === 7) {
    if (has("Q14")) return "PBG";
    return "Ext_PRS";
  }

  if ([8, 9].includes(moduleOrder)) return "PBG";

  return "PBG";
}

export function splitModuleRecommendationsByScore(
  recommendations: ModuleRecommendation[]
) {
  const grouped: ScoreModuleRecommendations = {
    PBG: [],
    Ext_PRS: [],
    E_Score: [],
  };

  const seenModuleOrders = new Set<number>();

  for (const recommendation of recommendations) {
    if (seenModuleOrders.has(recommendation.module_order)) continue;
    seenModuleOrders.add(recommendation.module_order);

    const bucket = moduleRecommendationBucket(
      recommendation.module_order,
      recommendation.trigger_reasons
    );

    grouped[bucket].push(recommendation);
  }

  return grouped;
}
